import Amplify, { Storage } from 'aws-amplify'
import config from './runtime'

/**
 * Configure AWS Amplify with appropriate settings based on environment
 */
export const configureAmplify = () => {
    if (!config.API) {
        Amplify.configure({
            Auth: {
                // REQUIRED - Amazon Cognito Identity Pool ID
                identityPoolId: 'us-east-1:e839f475-0266-4f7c-ba54-c6fb378169c7',
                // REQUIRED - Amazon Cognito Region
                region: 'us-east-1',
                // OPTIONAL - Amazon Cognito User Pool ID
                userPoolId: 'us-east-1_azTJlZeRb',
                // OPTIONAL - Amazon Cognito Web Client ID
                userPoolWebClientId: '7onkvofvfuirh2ak2t86hdv5cb',
            },
            Storage: {
                bucket: 'dev-heavyworth-ingestion', //REQUIRED -  Amazon S3 bucket
                region: 'us-east-1',
                customPrefix: {
                    public: '',
                    protected: '',
                    private: '',
                },
            },
            API: {
                endpoints: [
                    {
                        name: 'api',
                        endpoint: 'https://dev-api.heavyworth.com/v1',
                    },
                ],
            },
        })
    } else {
        /*
       Identity pool id: us-east-1:e839f475-0266-4f7c-ba54-c6fb378169c7
       User Pool Id: us-east-1_azTJlZeRb
       User Poot ARN: arn:aws:cognito-idp:us-east-1:019868025223:userpool/us-east-1_azTJlZeRb
       App Id: 4cdtf6udj7bp23ulo90vicbs67
        */
        Amplify.configure({
            Auth: {
                identityPoolId: config.AWS_IDENTITY_POOL,
                region: config.AWS_REGION,
                userPoolId: config.AWS_USER_POOL,
                userPoolWebClientId: config.AWS_APP_CLIENT,
                authenticationFlowType: config.AUTH_TYPE,
            },
            Storage: {
                bucket: config.INGEST_ENDPOINT,
                region: config.AWS_REGION,
                customPrefix: {
                    public: '',
                    protected: '',
                    private: '',
                },
            },
            API: {
                endpoints: [
                    {
                        name: 'api',
                        endpoint: config.API_ENDPOINT,
                    },
                ],
            },
        })
    }
    
    Storage.configure({ level: 'private' })
}